export default function Footer () {
    return <div className="py-3 bg-footer text-center text-white">&#9400; Suba Selvam 2024</div>
}